const CUSTOM_ELEMENT_ID = "formular-gewinnspiel";


class FormularGewinnspiel extends HTMLElement {

    constructor() {
        super();

        this.show = this.querySelector('.layer-show');
        this.close = this.querySelector('.layer-close');
        this.overlay = this.querySelector('.gs-layer-dialog');
        this.form = this.querySelector('.gs-form');
        this.success = this.querySelector('.gs-success');
        this.error = this.querySelector('.gs-error');
        this.footer = this.querySelector('.gs-footer');
        this.submitButton = this.querySelector('.gs-submit');

        this.initListener();
    }


    initListener() {
        this.form.addEventListener('submit', (event) => { return this.handleSubmit(event); });

        this.show.addEventListener('click', (event) => {
           this.overlay.showModal();
        });

        this.close.addEventListener('click', (event) => {
            this.overlay.close();
        });
    }

    async handleSubmit(event) {
        event.preventDefault();
        this.disableSubmit();

        const formData = new FormData(this.form);
        const config = {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                Accept: 'application/json'
            },
            body: formData
        };
        try {
            const response = await fetch("/api/newsletter/anmeldung", config);
            const json = await response.json();
            this.processResponse(json);
        } catch (error) {
            this.showErrorMessage('Es ist ein Problem aufgetreten.<br>Bitte versuchen Sie es später erneut.');
            throw error;
        } finally {
            this.enableSubmit();
        }
    }

    processResponse(data) {
        if (data.anmeldungErfolgreich) {
            this.showSuccessMessage();
        } else {
            this.showErrorMessage(data.newsletterMessage);
        }
    }

    showSuccessMessage() {
        this.success.classList.add('visible');
        this.form.classList.add('hidden');
        this.footer.classList.add('hidden');
    }

    showErrorMessage(errorMessage) {
        this.error.innerHTML = errorMessage;
        this.error.classList.add('visible');
    }

    disableSubmit() {
        this.submitButton.setAttribute('disabled', 'disabled');
        this.submitButton.setAttribute('data-loading', '');
    }

    enableSubmit() {
        this.submitButton.removeAttribute('disabled');
        this.submitButton.removeAttribute('data-loading');
    }

}


if (!customElements.get(CUSTOM_ELEMENT_ID)) {
    customElements.define(CUSTOM_ELEMENT_ID, FormularGewinnspiel);
}
